import './LogIn.css';
import React, {useContext, useState} from "react";
import {LogInState, Role} from "../../Utils/enums";
import {LoggedInContext} from "../../Utils/contexts";
import {logIn} from "../../Utils/queries";
import {faEye, faEyeSlash} from "@fortawesome/free-regular-svg-icons";
import {faUser, faLock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {get_login_validation_errors, get_password_validation_errors} from "../../Utils/validation";

enum LogInStatus{
    NotSent,
    WaitingForResponse,
    IncorrectLoginOrPassword,
    NetworkError
}

const Login = ({setRole, setUserId}: {setRole: React.Dispatch<React.SetStateAction<Role>>, setUserId: React.Dispatch<React.SetStateAction<number>>}) => {
    const logInHandler = useContext(LoggedInContext)!;

    const [login, setLogin] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [showPassword, setShowPassword] = useState(false);

    const [logInStatus, setLogInStatus] = useState<LogInStatus>(LogInStatus.NotSent);
    const [networkError, setNetworkError] = useState<number>(0);
    
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); 
        setLogInStatus(LogInStatus.WaitingForResponse);
        logIn(login.trim(), password.trim()).then(response => {
            if (response.errorCode){
                setNetworkError(response.errorCode);
                setLogInStatus(LogInStatus.NetworkError);
            } else if (!response.success) {
                setLogInStatus(LogInStatus.IncorrectLoginOrPassword);
            } else {
                setRole(response.role);
                setUserId(response.user_id);
                logInHandler(LogInState.LoggedIn);
            }
        });
    };
    
    const form_is_unfilled = login === "" || password === "";
    const login_err = get_login_validation_errors(login);
    const pwd_err = get_password_validation_errors(password);

    return (
        <div className="login-body">
            <div className="login-container">
                <h2 className="login-heading">MapID Login</h2>
                <p>Welcome! Please log in to manage CSI product categories.</p>
                <form id="loginForm" onSubmit={handleSubmit}>
                    <label className="login-label">Username:<FontAwesomeIcon icon={faUser} className="form-icon"/></label>
                    <input type="text" id="login" className="login-input"
                           value={login} disabled={logInStatus === LogInStatus.WaitingForResponse}
                           onChange={(event) => {
                               setLogin(event.target.value);
                               setLogInStatus(LogInStatus.NotSent);
                           }}/>
                    <label className="login-label"><FontAwesomeIcon icon={faLock} className="form-icon"/>Password:</label>
                    <input type={showPassword ? 'text' : 'password'} id="password" className="login-input"
                           value={password} disabled={logInStatus === LogInStatus.WaitingForResponse}
                           onChange={(event) => {
                               setPassword(event.target.value);
                               setLogInStatus(LogInStatus.NotSent);
                           }}/>
                    <p className="show-password" onClick={() => setShowPassword(prev => !prev)}>
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="form-icon"/>
                        {showPassword ? 'Hide Password' : 'Show Password'}
                    </p>
                    <p className="info-text-mini">
                        {logInStatus === LogInStatus.WaitingForResponse ?
                            "Waiting for response..." : ""}
                    </p>
                    <p className="error-text-mini">
                        {(login || password) && form_is_unfilled ?
                            "Please, fill all the fields" :
                            login_err? login_err: pwd_err? pwd_err:
                            logInStatus === LogInStatus.IncorrectLoginOrPassword ?
                                "Incorrect credentials!" :
                                logInStatus === LogInStatus.NetworkError ?
                                    `Error: ${networkError}` : ""
                        }
                    </p>
                    <button className="login-button green-button" type="submit"
                            disabled={form_is_unfilled || !!login_err || !!pwd_err || logInStatus === LogInStatus.WaitingForResponse}>Log In
                    </button>
                </form>
                <p>If you don't have an account, please <a href="http://t.me/wanna_be_a_hedgehog">contact the
                    administrator</a>.</p>
            </div>
        </div>
    );
};

export default Login;